module.exports = __webpack_public_path__ + "static/media/stage.49da39de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/stage.jpg
// module id = 384
// module chunks = 4